<template>
    <div>
        <div class="header">
            <h4>Education Posts</h4>
            <div class="buttons">
                <el-button type="primary" @click="create" size="mini" icon="el-icon-plus" round :loading="loadingNew">New</el-button>
            </div>
        </div>

        <Table :items="educationPosts" :columns="columns" :actions="actions" :loading="loading.announcements" />

        <EditDialog :item="item" :isOpen="showEditDialog" :onClose="() => showEditDialog = false" :fields="fields" />
    </div>
</template>

<script>
import { isEmpty, cloneDeep, pick } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Table from '@/components/Table';
import EditDialog from './EducationPostsDialog';

export default {
    name: 'education-posts',
    data() {
        return {
            columns: [
                { label: 'Title', prop: 'title' },
                { label: 'Post type', formatter: (item) => (item.post_type === 'video' ? `video ${item.length}` : item.post_type) },
                { label: 'Audience', prop: 'audience' },
                { label: 'Published?', formatter: (item) => (item.is_published ? "✅" : "❌") },
            ],
            actions: [
                { name: 'Edit', type: 'default', onClick: this.edit },
                { name: 'Duplicate', type: 'default', onClick: this.duplicate },
                { name: 'Remove', type: 'danger', onClick: this.remove, requiresConfirm: true },
            ],

            item: {},
            showEditDialog: false,
            loadingNew: false,

            fields: ['title', 'tag', 'post_type', 'audience', 'length', 'tag', 'src', 'is_published']
        };
    },
    components: {
        Table,
        EditDialog
    },
    mounted() {
        if (isEmpty(this.educationPosts)) this.getEducationPosts();
    },
    computed: mapGetters(['educationPosts', 'loading']),
    methods: {
        ...mapActions(['getEducationPosts']),
        edit(item) {
            this.item = cloneDeep(item);
            this.showEditDialog = true;
        },
        async create(payload = {}) {
            try {
                this.loadingNew = true
                const { data } = await this.$api.post('/product/education_posts', payload);
                this.edit(data);
                this.getEducationPosts();
            } catch (err) {
                this.$notify.error({ title: 'Failed creating a new post.' });
            } finally {
                this.loadingNew = false
            }
        },
        duplicate(item) {
            const data = pick(item, this.fields);
            this.create(data);
        },
        async remove(item) {
            try {
                await this.$api.delete(`/product/education_posts/${item.id}`);
                this.$message.info('The post has been removed.');
                this.getEducationPosts();
            } catch (err) {
                this.$notify.error({
                    title: 'Couldn\'t remove post :(',
                    message: err.message
                });
            }
        }
    }
}
</script>

<style scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
}
h4 {
    margin-right: 10px;
}
</style>
